export const googleFonts: string[] = [
  'Arial',
  'Open Sans',
  'Roboto',
  'Lato',
  'Montserrat',
  'Roboto Condensed',
  'Oswald',
  'Source Sans Pro',
  'Raleway',
  'PT Sans',
  'Roboto Slab',
  'Merriweather',
  'Ubuntu',
  'Playfair Display',
  'Noto Sans',
  'Poppins',
  'Lora',
  'PT Serif',
  'Roboto Mono',
  'Arimo',
  'Titillium Web',
  'Times New Roman',
].sort();
